var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "video-form-component" } },
    [
      _c("input", {
        attrs: { type: "hidden", name: _vm.input_name, id: _vm.input_id },
        domProps: { value: _vm.video.id }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "media_video_status" },
        domProps: { value: _vm.video.status }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: {
          type: "hidden",
          name: "media_video_available",
          id: "product_media_video_available"
        },
        domProps: { value: _vm.video.status === "COMPLETE" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-b-40" },
        [
          !_vm.is_card_form ? _c("h6", [_vm._v("File Upload")]) : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "small m-b-0" }, [
            _vm._v("Supported formats: MP4, WEBM, MOV, AVI, MKV, FLV")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "small m-b-0" }, [
            _vm._v("Minimum duration = 10 seconds")
          ]),
          _vm._v(" "),
          _vm.is_card_form
            ? _c("p", { staticClass: "small" }, [
                _vm._v("Maximum file size 3GB")
              ])
            : _c("p", { staticClass: "small" }, [
                _vm._v("Maximum file size 10GB or 3 hours run-time")
              ]),
          _vm._v(" "),
          _vm.hasErrors ||
          (_vm.video.status === "COMPLETE" && _vm.video_editable)
            ? _c("div", { staticClass: "edit-video" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.uploadNewVideo()
                      }
                    }
                  },
                  [_vm._v("Upload new Video")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectTimelineMode
            ? _c("poster-from-timeline", {
                attrs: { "class-name": _vm.is_card_form ? "cardForm" : "" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.video.status !== "COMPLETE"
            ? _c("upload-video", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.selectTimelineMode,
                    expression: "!selectTimelineMode"
                  }
                ],
                attrs: { kind: "main", for_product: _vm.for_product }
              })
            : _c("theo-player", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.selectTimelineMode,
                    expression: "!selectTimelineMode"
                  }
                ],
                attrs: { kind: "main" }
              }),
          _vm._v(" "),
          _vm.for_product
            ? _c(
                "div",
                {
                  staticClass: "set-drm-content",
                  attrs: {
                    title:
                      _vm.video.status === "COMPLETE"
                        ? "video already processed"
                        : _vm.videoStartTranscode
                        ? "video in progress"
                        : ""
                  }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.digital_access,
                        expression: "digital_access"
                      }
                    ],
                    staticClass: "styled-checkbox",
                    attrs: {
                      id: "drm_content",
                      type: "checkbox",
                      disabled: _vm.videoStartTranscode,
                      "true-value": "private",
                      "false-value": "protected"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.digital_access)
                        ? _vm._i(_vm.digital_access, null) > -1
                        : _vm._q(_vm.digital_access, "private")
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.digital_access,
                          $$el = $event.target,
                          $$c = $$el.checked ? "private" : "protected"
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.digital_access = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.digital_access = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.digital_access = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "purchase-label",
                      attrs: { for: "drm_content" }
                    },
                    [_vm._v("DRM content")]
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.can_edit_video
        ? _c(
            "div",
            { staticClass: "m-b-40" },
            [
              _c("h6", [_vm._v("Thumbnail")]),
              _vm._v(" "),
              _c("posters-nav", {
                attrs: {
                  kind: "main",
                  "class-name": _vm.is_card_form ? "cardForm" : ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.is_card_form
        ? _c(
            "div",
            [
              _c("div", { staticClass: "m-b-40" }, [_c("select-preview")], 1),
              _vm._v(" "),
              _c("modal-preview")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.video.id && _vm.can_edit_video
        ? _c("div", { staticClass: "m-b-40" }, [_c("subtitles-nav")], 1)
        : _vm._e(),
      _vm._v(" "),
      !_vm.is_card_form ? _c("hr") : _vm._e(),
      _vm._v(" "),
      _vm.for_product
        ? _c("modal-dont-leave", { attrs: { for_product: _vm.for_product } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }